module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@3x.e0c8d44b.png";